import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import AuthGuard from "./components/AuthGuard";
import GuestGuard from "./components/GuestGuard";
import Login from "./pages/auth/Login";
import Layout from "./pages/dashboard/Layout";
import Home from "./pages/dashboard/Home";
import OrgInfo from "./pages/base/OrgInfo";
import Positions from "./pages/base/Positions";
import Employees from "./pages/base/Employees";
import Shifts from "./pages/base/Shifts";
import MyShifts from "./pages/work/MyShifts";
import Jobs from "./pages/base/Jobs";
import Tasks from "./pages/work/Tasks";
import Missions from "./pages/work/Missions";
import Pledges from "./pages/records/Pledges";
import Incidents from "./pages/records/Incidents";
import Requests from "./pages/records/Requests";
import Letters from "./pages/records/Letters";
import Expenses from "./pages/records/Expenses";
import Reports from "./pages/reports/Reports";
import Settings from "./pages/settings/Settings";
import LeaveApprovals from "./pages/work/LeaveApprovals";
import AssignedTasks from "./pages/work/AssignedTasks";
import Equipment from "./pages/base/Equipment";
import Warehouse from "./pages/base/Warehouse";
import Property from "./pages/base/Property";
import Directives from "./pages/work/Directives";
import ManagerLetters from "./pages/records/ManagerLetters";
import ManagerInbox from "./pages/work/ManagerInbox";
import Violations from "./pages/records/Violations";

const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    ),
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      { index: true, element: <Home /> },
      { path: "base/org", element: <OrgInfo /> },
      { path: "base/positions", element: <Positions /> },
      { path: "base/employees", element: <Employees /> },
      { path: "base/shifts", element: <Shifts /> },
      { path: "my-shifts", element: <MyShifts /> },
      { path: "base/jobs", element: <Jobs /> },
      { path: "tasks", element: <Tasks /> },
      { path: "missions", element: <Missions /> },
      { path: "pledges/:kind", element: <Pledges /> },
      { path: "incidents", element: <Incidents /> },
      { path: "requests/:scope", element: <Requests /> },
      { path: "reports", element: <Reports /> },
      { path: "letters", element: <Letters /> },
      { path: "expenses", element: <Expenses /> },
      { path: "settings", element: <Settings /> },
      { path: "leave-approvals", element: <LeaveApprovals /> },
      { path: "assigned-tasks", element: <AssignedTasks /> },
      { path: "equipment", element: <Equipment /> },
      { path: "warehouse", element: <Warehouse /> },
      { path: "property", element: <Property /> },
      { path: "directives", element: <Directives /> },
      { path: "manager-letters", element: <ManagerLetters /> },
      { path: "manager-inbox", element: <ManagerInbox /> },
      { path: "violations", element: <Violations /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}

